
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { saveUserSubmission } from '@/services/user/userSubmissionService';
import type { Word } from '@/lib/game-utils';

export function useSavePlayerRanking(orderedSelectedWords: Array<Word | string>) {
  const [rankingSaved, setRankingSaved] = useState(false);

  // Save player ranking to Supabase if not already saved
  useEffect(() => {
    const savePlayerRanking = async () => {
      if (rankingSaved) return;
      
      try {
        const userEmail = localStorage.getItem("user_email");
        if (!userEmail) {
          console.log("[OrderComparison] No user email found, cannot save ranking");
          return;
        }
        
        const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
        
        // First, try to get the game ID for today
        const { data: gameData, error: gameError } = await supabase
          .from('games')
          .select('id')
          .eq('date', today)
          .maybeSingle();
          
        if (gameError || !gameData?.id) {
          console.error("[OrderComparison] Error finding game:", gameError);
          return;
        }
        
        // Format the player's ranking as an array of words in order
        const playerRanking = orderedSelectedWords.map(word => String(word));
        
        // Use the dedicated service function to save the submission
        const success = await saveUserSubmission(
          gameData.id,
          userEmail,
          playerRanking
        );
        
        if (success) {
          console.log("[OrderComparison] Successfully saved player ranking");
          setRankingSaved(true);
        }
      } catch (error) {
        console.error("[OrderComparison] Error in savePlayerRanking:", error);
      }
    };
    
    savePlayerRanking();
  }, [orderedSelectedWords, rankingSaved]);

  return { rankingSaved };
}
